module.exports = __webpack_public_path__ + "img/horizontal_3_3_pp3_7016.cebb08c9.png";